import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import styles from './GenderGraph.module.css'
// Register the necessary components
ChartJS.register(ArcElement, Tooltip, Legend);

const GenderDoughnutChart = ({ data }) => {

    const genderList = data.genderCount || [];

    // Prepare data for the chart
    const config = {
        labels: genderList.map(gender => gender._id),
        datasets: [
            {
                label: 'Gender Distribution',
                data: genderList.map(gender => gender.count),
                backgroundColor: [
                    'rgba(255, 99, 132, 0.6)',
                    'rgba(54, 162, 235, 0.6)',
                    'rgba(255, 206, 86, 0.6)',
                    'rgba(75, 192, 192, 0.6)'
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)'
                ],
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Gender Distribution',
            },
        },
    };

    return (
        <div className={styles.chart_wrap}>
            {/* {data?.monthlyCounts?.enterpriseCounts ? ( */}
            < Doughnut data={config} options={options} />
            {/* ) : (
            <div className={styles.loader_wrap}>
                <Spin />
            </div>
            )} */}
        </div>
    )



};

export default GenderDoughnutChart;